import React from 'react';

import { IAppointmentConfig } from '@bb/domain/dist/types';
import { useContactState, useContactModalState } from './hooks';
import { ContentLayout } from './components';
import ContactInputs from './ContactInputs';
import SendNotifications from './SendNotifications';
import MultiConfListing from './MultiConfListing';
import Permissions from './Permissions';

type ContactContentProps = {
  contacts?: IAppointmentConfig['contacts'];
  isMultiConf: boolean;
};

const ContactContent: React.FC<ContactContentProps> = ({
  contacts,
  isMultiConf,
}) => {
  const [contactState] = useContactState();
  const [contactModalState] = useContactModalState();

  return (
    <ContentLayout
      detailsSection={
        <ContactInputs
          contacts={contacts}
          addBuyerContact={contactState.type === 'Buyer'}
        />
      }
      notificationsSection={<SendNotifications />}
      permissionsSection={
        isMultiConf && !contactModalState.isEditMode ? (
          <>
            <MultiConfListing />
            {contactState.mustConfirm && <Permissions />}
          </>
        ) : (
          <Permissions />
        )
      }
      showPermission={contactState.type !== 'Buyer'}
    />
  );
};

export default ContactContent;
